import { BaseEntity, type Searchable } from './base'

export class DeadlineType extends BaseEntity implements Searchable {
  displayName!: string
  icon!: string
  color!: string | null
  visible!: boolean
  category!: string | null

  get searchString() {
    return this.displayName + ' ' + (this.category || '')
  }
}

export class NewDeadlineType {
  displayName!: string
  icon!: string
  color?: string | null
  visible?: boolean
  category?: string | null
}

export class EditDeadlineType {
  displayName?: string
  icon?: string
  color?: string | null
  visible?: boolean
  category?: string | null
}

export interface DeadlineTypeWritten {
  deadlineType: DeadlineType
}

export interface GetDeadlineTypes {
  deadlineTypes: DeadlineType[]
}

export class DeadlineBadge extends BaseEntity implements Searchable {
  displayName!: string
  color!: string
  visible!: boolean

  get searchString(): string {
    return this.displayName
  }
}

export interface GetDeadlineBadges {
  deadlineBadges: DeadlineBadge[]
}

export class NewDeadlineBadge {
  displayName!: string
  color!: string
}

export class EditDeadlineBadge {
  displayName?: string
  color?: string
  visible?: boolean
}
